import { Link } from "react-router-dom";
import "./loan-sections.css";

const APPLY_URL =
  "https://www.las.tatacapital.com/online/loans/las/apply-now-las-loan?sourceName=GPS_FINVEST_PRIVATE_LIMITED#!";

export default function LoanFinalCta() {
  return (
    <section className="loan-final-cta">
      <div
        className="loan-final-cta-bg"
        style={{ backgroundImage: "url(/images/loan-cta-dreams-bg.png)" }}
        aria-hidden="true"
      />
      <div className="loan-final-cta-inner">
        <h2>Ready to Fulfill Your Dreams?</h2>
        <p>Get the right loan with the best offers and expert guidance.</p>
        <div className="loan-final-cta-actions">
          <a
            href={APPLY_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="loan-final-btn loan-final-btn--primary"
          >
            Apply Now
          </a>
          <Link to="/contact" className="loan-final-btn loan-final-btn--ghost">
            Talk to an Expert
          </Link>
        </div>
      </div>
    </section>
  );
}
